import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps, RMType } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { styles } from '../../Styles/styles';
import {
  applicationCreatedBy,
  isDistributorTypeCompany,
  labelForDistributorAdvisorRmNumber,
} from '../../utils/utilityFunctions';
import { Distributor, SubDistributor } from '../../redux-store/actions';
import { DistributorMode } from '../../utils/constant';
import { POAAuthorizedSignatry } from '../NonIndividualApplicationDetails/AuthorisedSignatories';
import {
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
} from '../../utils/utilityFunctions';
import {
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  poaValidationDate,
} from '../../utils/constant';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const distributorAdvisorLabel = applicationCreatedBy(
    application?.rm as RMType,
    application?.distributor as Distributor,
    application?.subDistributor as SubDistributor,
    application?.createdBy as string,
    false
  );
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                {applicationCreatedBy(
                  application.rm as RMType,
                  application.distributor as Distributor,
                  application.subDistributor as SubDistributor,
                  application.createdBy as string
                )}
              </Typography>
            </Grid>

            <Gridstyles sx={{ width: '100%' }}>
              <Grid
                item
                container
                pt={1}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {application?.distributor_id ? (
                  <>
                    <KeyValue
                      title={`${distributorAdvisorLabel || 'Distributor'} Code`}
                      description={
                        application?.distributorArnCode || application?.distributor?.arnCode
                      }
                    />
                    <KeyValue
                      title={`${distributorAdvisorLabel || 'Distributor'} Name`}
                      description={application?.distributor?.name}
                    />
                    <KeyValue
                      title={'Mode'}
                      description={DistributorMode[application?.distributor?.mode]}
                    />
                    {isDistributorTypeCompany(application?.distributor) ? (
                      <>
                        <KeyValue
                          title={'Filled By'}
                          description={application?.subDistributor?.user?.firstName}
                        />
                        <KeyValue
                          title={'Email'}
                          description={application?.subDistributor?.user?.email}
                        />

                        <KeyValue
                          title={`${distributorAdvisorLabel || 'Distributor'} RM Name`}
                          description={application?.amcDistributorName}
                        />
                        <KeyValue
                          title={`${distributorAdvisorLabel || 'Distributor'} RM Email`}
                          description={application?.amcDistributorEmail}
                        />
                        <KeyValue
                          title={`${labelForDistributorAdvisorRmNumber(
                            distributorAdvisorLabel
                          )} Phone Number`}
                          description={`${
                            application?.amcDistributorCountryCode
                              ? `${application?.amcDistributorCountryCode}-`
                              : ''
                          }${application?.amcDistributorMobile}`}
                        />
                      </>
                    ) : (
                      <>
                        <KeyValue
                          title={'Email'}
                          description={application?.distributor?.user?.email}
                        />
                        <KeyValue
                          title={`${labelForDistributorAdvisorRmNumber(
                            distributorAdvisorLabel
                          )} Phone Number`}
                          description={`${
                            application?.distributor?.user?.countryCode
                              ? `${application?.distributor?.user?.countryCode}-`
                              : ''
                          }${application?.distributor?.user?.phone}`}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <KeyValue title={'RM Name'} description={application?.rm?.name} />
                    <KeyValue title={'RM Email ID'} description={application?.rm?.user?.email} />
                  </>
                )}
                <KeyValue title={'ASK RM Name'} description={application?.rmName} />
              </Grid>
            </Gridstyles>
          </Grid>
          {application?.poaauthorisedsignatories?.length >= 0 &&
            checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
            checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Authorised Signatories
                </Typography>
                {application?.poaauthorisedsignatories?.length === 0 ? (
                  <Grid
                    xs={12}
                    sm={12}
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'common.black',
                      textAlign: 'center',
                      my: 3,
                    }}>
                    No Authorised Signatories
                  </Grid>
                ) : (
                  <POAAuthorizedSignatry />
                )}
              </Grid>
            )}
        </Box>
      </Box>
    </>
  );
}
